import React from 'react'
import type Konva from 'konva'

interface IContext {
  previewPlayer: HTMLDivElement | null,
  previewPlayerBox: React.MutableRefObject<HTMLDivElement | null>,
  onSetPreviewPlayer: React.RefCallback<HTMLDivElement>,
  imageSource: HTMLImageElement | undefined,
  canvasSource: Konva.Stage | undefined,
  videoSource: HTMLVideoElement | undefined,
  setImageSource(object: HTMLImageElement | undefined): void,
  setCanvasSource(object: Konva.Stage | undefined): void,
  setVideoSource(object: HTMLVideoElement | undefined): void,
  handleFullscreen(): void,
  captureFrame(isMedia: boolean, onCaptured?: (dataUrl: string, fileName: string) => void, mimeType?: string): void,
}

export const PreviewPlayerContext = React.createContext<IContext>({} as IContext)
